module.exports = __webpack_public_path__ + "media/images/submit-9e3dc47529090cb432b040f67609d476.svg";